import Script from 'next/script';
import type { TenantId } from '../../../tenants/types/tenant';
import { isZoocasaTenant } from '@tenants';

interface ZoocasaScriptProps {
  id: string;
  strategy: 'beforeInteractive' | 'afterInteractive';
  functionalCookiesEnabled: boolean;
  tenantId: TenantId;
  src?: string;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}

export const ZoocasaScript = ({ id, strategy, functionalCookiesEnabled, tenantId, src, dangerouslySetInnerHTML }: ZoocasaScriptProps) => {
  const isTenantZoocasa = isZoocasaTenant(tenantId);

  if (!functionalCookiesEnabled || !isTenantZoocasa) {
    return null;
  }

  return <Script id={id} strategy={strategy} src={src} dangerouslySetInnerHTML={dangerouslySetInnerHTML} />;
};
